import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "gender", "nationality", "dateOfBirth"]

  connect() {
    this.update()
  }

  inputTargetConnected() {
    this.inputTarget.addEventListener("input", () => this.update())
  }

  update() {
    if (!this.hasInputTarget) return
    if (this.inputTarget.disabled) return
    const cleaned = this.inputTarget.value.replace(/\D/g, "")
    if (cleaned.length !== 13) {
      this.clearDerivedFields()
      return
    }

    const yy = parseInt(cleaned.slice(0, 2), 10)
    const mm = parseInt(cleaned.slice(2, 4), 10)
    const dd = parseInt(cleaned.slice(4, 6), 10)
    const currentYear = new Date().getFullYear() % 100
    const century = yy > currentYear ? 1900 : 2000

    const birthDate = new Date(century + yy, mm - 1, dd)
    if (Number.isNaN(birthDate.getTime()) || !this.matchesOriginalDate(birthDate, century + yy, mm, dd)) {
      this.clearDerivedFields()
      return
    }

    const genderCode = parseInt(cleaned.slice(6, 10), 10)
    const nationalityCode = parseInt(cleaned.slice(10, 11), 10)

    if (this.hasGenderTarget) {
      const genderValue = genderCode >= 5000 ? "Male" : "Female"
      this.genderTarget.value = genderValue
    }

    if (this.hasNationalityTarget) {
      this.nationalityTarget.value = nationalityCode === 0 ? "South African" : "Non-South African"
    }

    if (this.hasDateOfBirthTarget) {
      const formatted = this.formatDate(birthDate)
      this.dateOfBirthTarget.value = formatted
      this.dispatchDateOfBirthUpdated()
    }
  }

  clearDerivedFields() {
    if (this.hasGenderTarget) this.genderTarget.value = ""
    if (this.hasNationalityTarget) this.nationalityTarget.value = ""
    if (this.hasDateOfBirthTarget) {
      this.dateOfBirthTarget.value = ""
      this.dispatchDateOfBirthUpdated()
    }
  }

  dispatchDateOfBirthUpdated() {
    if (!this.hasDateOfBirthTarget) return
    const inputEvent = new Event("input", { bubbles: true })
    const changeEvent = new Event("change", { bubbles: true })
    this.dateOfBirthTarget.dispatchEvent(inputEvent)
    this.dateOfBirthTarget.dispatchEvent(changeEvent)
  }

  matchesOriginalDate(date, year, month, day) {
    return date.getFullYear() === year && date.getMonth() + 1 === month && date.getDate() === day
  }

  formatDate(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }
}
